import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikInput } from 'components/UiKit/FormikFields';

const FSAArea = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikInput
      placeholder="Enter area"
      name="fsaArea"
      label="FSA Area"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default FSAArea;
